module.exports = __webpack_public_path__ + "img/theme-six.8e7cf7f1.png";